import 'babel-polyfill';
import 'url-polyfill';
import React, { Component } from 'react';
import { Switch } from 'react-router'
import { HashRouter as Router } from 'react-router-dom';
import 'react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'react-rangeslider/lib/index.css'
import './index.css';
import { Route } from "react-router-dom";
import UnauthenticatedRoute from './core/components/UnauthenticatedRoute';
import Login from './auth/components/Login';
import { ToastContainer } from 'react-toastify';
import Version from './auth/components/Version'
import LoadingScreen from './LoadingScreen';
import { utils } from "./core/helpers/utils";
import { getEncryptedPKey } from "./waitlist/services/waitlist-service";
class App extends Component {
  constructor() {
    super();

    this.state = {
      isProxySet: false,
      // pkey: ""
    }

    this.setProxy = this.setProxy.bind(this);
  }

  componentDidMount() {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "slv8f0utb3"); // <-- Your Project ID here
    let pkey = utils.getPKey();

    if (process.env.REACT_APP_IS_PKEY === "true") {
      if (!pkey) {
        getEncryptedPKey().then(res => {
          this.setState({ pkey: res, isProxySet: true });
          pkey = res;

          this.setProxy(pkey);
        });
      } else {
        this.setProxy(pkey);
      }
    } else {
      this.setProxy();
    }
  }

  

  setProxy(pkey) {
    // (function () {

    let oldFetch = window.fetch;

    if (!oldFetch) {
      return;
    }

    const handler = {
      apply: function (target, thisArg, argumentsList) {
        // console.log("proxy ,", "\n", target, "\n", thisArg, "\n", argumentsList);
        // debugger;

        /* argv: url, options */
        if (!argumentsList || !argumentsList.length ||
          !argumentsList[0]) {
          /* no url provided */
          console.log("skipped proxy for fetch()")
          return target.apply(thisArg, argumentsList);
        }

        let flag = false;
        let url = argumentsList[0];
        let subdomains = process.env.REACT_APP_BASE_API_DOMAINS.split(","); //["uatapi"];

        if (subdomains.reduce((flag, subd) => flag || url.includes(subd), false)) {
          // console.log("proxy ,", "\n", target, "\n", thisArg, "\n", argumentsList);
          let options = argumentsList[1];
          let headers = options["headers"];
          let usePkey = true;

          if (argumentsList.length <= 1) {
            argumentsList.push({})
          }

          try {
            if (typeof headers["use-pkey"] && headers["use-pkey"] == false) {
              usePkey = false;
            }
          } catch (ex) {
            //
          }
          // console.log("usePkey: ", usePkey);

          if ((headers?.["credentials"] || options["credentials"] && options["credentials"] == "include") && usePkey && pkey) {
            headers["x-encrypted-data"] = true;
            headers["x-web-version"] = String(process.env.REACT_APP_VERSION);
            headers["site-url"] = window.location.hostname;

            // console.log("indexOf: ", argumentsList.indexOf(/[auth\/login]/gi));
            // if (argumentsList.indexOf(/[auth\/login]/gi) != -1) {
            //   //
            // } else {
            // headers["x-encrypted-data"] = true;
            const params = { payload1: pkey };
            const query = Object.keys(params)
              .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
              .join("&");
              // console.log("\nquery: ", query, "\nbody: ", options?.body);
            argumentsList[0] = url.indexOf("?") != -1 ? url + "&" + query : url + "?" + query;
            // console.log("\nargumentsList: ", String(argumentsList[0]));
            // }
            /* const params = { payload1: pkey };
            const query = Object.keys(params)
              .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
              .join("&");
            argumentsList[0] = url.indexOf("?") != -1 ? url + "&" + query : url + "?" + query; */
          }

          if (!usePkey) {
            delete headers["use-pkey"];
            // delete headers["Use-Pkey"];
          }

          // console.log("proxy: updated options: ", "\n", url, "\n", options);
        }

        return target.apply(thisArg, argumentsList);
      }
    };

    window.fetch = new Proxy(oldFetch, handler);
    // })();
  }

  render() {
    if (process.env.NODE_ENV === 'production') {
      console.log = function () { };
    }
    return (
      <Router>
        <Switch>
          {/*<UnauthenticatedRoute exact path="/" component={Home} />
                    <UnauthenticatedRoute exact path="/login" component={Login} />
                    <UnauthenticatedRoute exact path="/signup" component={Signup} />*/}
          <UnauthenticatedRoute exact path="/login" component={Login} />
          <Route exact path="/version" component={Version} />
          <Route path="/" component={LoadingScreen} />
          <ToastContainer />
        </Switch>
      </Router>
    );
  }
}

export default App;